module.exports = __webpack_public_path__ + "static/media/rugby-icon.7500e0e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rugby-icon.svg
// module id = 42
// module chunks = 0